export function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  // Standard iOS detection + iPad desktop mode (reports as MacIntel but has touch)
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

export function isWebSpeechReliable(): boolean {
  if (typeof window === "undefined") return false;
  const hasAPI =
    "SpeechRecognition" in window || "webkitSpeechRecognition" in window;
  return hasAPI && !isIOS();
}
